module.exports = __webpack_public_path__ + "img/产品中心.c3309e8b.jpg";